import { copy } from '../../data/website';

export const Approach = () => <section id="approach" className="section-space gee-approach" data-testid="approach-section">
  <div className="site-container">
    <p className="eyebrow" data-testid="approach-section-label">{copy.approach.label}</p><h2 className="gee-heading" data-testid="approach-heading">{copy.approach.heading}</h2><p className="gee-intro-copy">{copy.approach.intro}</p>
    <ol className="gee-approach-steps">{copy.approach.steps.map((step, i) => <li id={`approach-step-${i + 1}`} key={step.title} data-testid={`approach-step-${i + 1}`}><h3>{step.title}</h3><p>{step.description}</p></li>)}</ol>
    <p className="gee-approach-closing" data-testid="approach-closing">{copy.approach.closing}</p>
  </div>
</section>;